import React from 'react';
import './dateInput.scss';


const DateInput = (props) => {

  return (
    <div className='date-main'>
      <label style={{color: 'black'}} htmlFor={props.id}>{props.label}</label>
      <input
      type='date'
      placeholder="dd-mm-yyyy"
      id={props.id}
      name={props.name}
      onChange={props.onChange}
      value={props.value}
      style={props.style}
      />
      <span className='date-input__note' >{props.note}</span>
    </div>
  )
}

export default DateInput